<template>
  <div class="contact-form">
    <b-form @submit="onSubmit" v-if="show">
      <b-form-group id="input-group-1">
        <p class="mb-1">Họ tên<span class="required">*</span></p>
        <b-form-input
          id="fullname"
          v-model="form.fullname"
          type="fullname"
          placeholder="Họ tên của anh/chị"
          required
        ></b-form-input>
      </b-form-group>

      <b-form-group id="input-group-2">
        <p class="mb-1">Số điện thoại<span class="required">*</span></p>
        <b-form-input
          id="phone"
          v-model="form.phone"
          placeholder="VD: 0123456789"
          required
        ></b-form-input>
      </b-form-group>

      <b-form-group id="input-group-3">
        <p class="mb-1">Mô tả nhu cầu</p>
        <b-form-textarea
          id="needs_contact"
          v-model="form.needs_contact"
          rows="3"
          max-rows="6"
        ></b-form-textarea>
      </b-form-group>

      <b-button type="submit" variant="success">{{
        isLoading ? "Đang xử lý..." : "Đăng ký"
      }}</b-button>
    </b-form>
  </div>
</template>

<script>
import TableMeta from "./ContactTableMeta";
import Constants from "@/constants";
import axios from "axios";
import moment from "moment";

export default {
  name: "ContactForm",
  data() {
    return {
      forms: TableMeta.input_view.forms,
      columns: TableMeta.columns,
      table_name: TableMeta.table_name,

      form: {
        fullname: "",
        phone: "",
        needs_contact: "",
      },
      show: true,
      isLoading: false,
    };
  },
  computed: {},
  watch: {},
  methods: {
    async insertNewRecord() {
      this.isLoading = true;
      const clientDataForDb = {
          fullname: this.form.fullname,
          phone: this.form.phone,
          needs_contact: this.form.needs_contact || "",
      };

      try {
          // Step 1: Create client in DB
          const createClientUrl = Constants.HOST_URL + "createClient";
          const dbResponse = await axios.post(createClientUrl, clientDataForDb);
          
          console.log(dbResponse.data);
          const createdClient = dbResponse.data;

          // Step 2: Submit to Omicall
          try {
              const submitOmicallUrl = Constants.HOST_URL + "submitToOmicall";
              await axios.post(submitOmicallUrl, {
                  code: createdClient.code,
                  fullname: createdClient.fullname,
                  phone: createdClient.phone,
                  needs_contact: createdClient.needs_contact,
              });
          } catch (omicallError) {
              console.error("Omicall submission failed, but client was saved to DB", omicallError);
              // Log the error, but don't show an error to the user since the main operation succeeded.
          }

          alert("Cảm ơn quý anh/chị đã quan tâm. Chúng tôi sẽ liên hệ lại trong thời gian sớm nhất.");
          this.form = { fullname: "", phone: "", needs_contact: "" };

      } catch (e) {
          console.error("Error creating client:", e);
          let errorMessage = "Có lỗi xảy ra khi gửi thông tin. Vui lòng thử lại.";
          if (e.response && e.response.data && e.response.data.error) {
              errorMessage = e.response.data.error;
          }
          alert(errorMessage);
      } finally {
          this.isLoading = false;
      }
    },

    async onSubmit(event) {
      event.preventDefault();
      this.isLoading = true;
      // alert(JSON.stringify(this.form));
      await this.insertNewRecord();
    },
  },
  mounted() {},
};
</script>

<style scoped>
.contact-form {
  padding: 25px;
  background: #fff;
  border: 1px solid #eae6e6;
}
.required {
  color: red;
}
</style>
